module.exports = __webpack_public_path__ + "img/icon-watermark.360a5e1a.png";